import React from 'react';

export default ({ color, width, height }) => (
  <svg version="1.1" id="Layer_1" width={width} height={height} viewBox="0 0 74 48">
    <g id="Page-1">
      <g id="Controller">
        <path
          id="Path"
          style={{ fill: color }}
          d="M54.7,7.9l-0.5,0.5c-0.8,0.8-0.8,2.1,0,2.9l0.5,0.5c0.8,0.8,2.1,0.8,2.9,0l0.5-0.5
			c0.8-0.8,0.8-2.1,0-2.9l-0.5-0.5C56.8,7.1,55.5,7.1,54.7,7.9z"
        />
        <path
          id="Path_1_"
          style={{ fill: color }}
          d="M54.7,16.4l-0.5,0.5c-0.8,0.8-0.8,2.1,0,2.9l0.5,0.5c0.8,0.8,2.1,0.8,2.9,0l0.5-0.5
			c0.8-0.8,0.8-2.1,0-2.9l-0.5-0.5C56.9,15.6,55.6,15.6,54.7,16.4z"
        />
        <path
          id="Path_2_"
          style={{ fill: color }}
          d="M59,12.1l-0.5,0.5c-0.8,0.8-0.8,2.1,0,2.9L59,16c0.8,0.8,2.1,0.8,2.9,0l0.5-0.5
			c0.8-0.8,0.8-2.1,0-2.9l-0.5-0.5C61.1,11.3,59.8,11.3,59,12.1z"
        />
        <path
          id="Path_3_"
          style={{ fill: color }}
          d="M50.5,12.1L50,12.6c-0.8,0.8-0.8,2.1,0,2.9l0.5,0.5c0.8,0.8,2.1,0.8,2.9,0l0.5-0.5
			c0.8-0.8,0.8-2.1,0-2.9l-0.5-0.5C52.6,11.3,51.3,11.3,50.5,12.1z"
        />
        <path
          id="Shape"
          style={{ fill: color }}
          d="M14.8,20.2h4.9v-3.7h3.7v-4.9h-3.7V7.9h-4.9v3.7h-3.7v4.9h3.7V20.2z M16.1,15.3v-2.5h2.6v2.6
			L16.1,15.3z"
        />
        <path
          id="Shape_1_"
          style={{ fill: color }}
          d="M8.2,47.3c1.3,0,2.7-0.3,3.9-1c1.2-0.6,2.2-1.5,3-2.7l8.3-12.3c0.8,0.6,1.8,1,2.8,1.1
			c1,0.1,2,0,3-0.4c0.9-0.4,1.8-1,2.4-1.7c0.6-0.8,1.1-1.7,1.3-2.7h7.5c0.2,1,0.6,1.9,1.3,2.7c0.6,0.8,1.5,1.4,2.4,1.7
			c0.9,0.4,2,0.5,3,0.4c1-0.1,2-0.5,2.8-1.1l8.3,12.3c1,1.5,2.4,2.6,4.1,3.2c1.7,0.6,3.5,0.6,5.2,0.1c1.7-0.5,3.2-1.6,4.2-3
			c1.1-1.4,1.6-3.1,1.6-4.9V21.6c0-4.5-1.5-8.8-4.2-12.4c-2.8-3.5-6.7-6-11.1-7c-2.6-0.6-5.2-1.1-7.9-1.5L48,0.6l-0.6-0.1
			c-0.7-0.1-1.5-0.1-2.3-0.2h-0.5c-0.8-0.1-1.6-0.1-2.5-0.2h-0.2c-3.5-0.2-7-0.2-10.5,0h-0.2c-0.8,0-1.6,0.1-2.5,0.2h-0.5
			c-0.8,0.1-1.5,0.1-2.3,0.2l-0.7,0.1l-2,0.2c-2.7,0.4-5.3,0.9-7.9,1.5C11,3.3,7.1,5.7,4.3,9.3C1.5,12.8,0,17.1,0,21.6V39
			c0,2.2,0.9,4.3,2.4,5.8C4,46.4,6.1,47.3,8.2,47.3z M27,30.9c-0.7,0-1.4-0.2-2-0.6c-0.6-0.3-1.2-0.8-1.6-1.4l-0.2-0.3
			c0-0.1-0.1-0.3-0.2-0.4c0-0.1-0.1-0.3-0.1-0.5c0-0.2-0.1-0.2-0.1-0.3c-0.1-0.3-0.1-0.6-0.1-0.8c0-0.9,0.3-1.7,0.7-2.4
			c0.5-0.7,1.1-1.3,1.9-1.6c0.8-0.3,1.7-0.4,2.5-0.2s1.6,0.6,2.2,1.2c0.6,0.6,1,1.4,1.2,2.2c0.2,0.8,0.1,1.7-0.2,2.5
			c-0.3,0.8-0.9,1.5-1.6,1.9C28.7,30.7,27.8,30.9,27,30.9z M42,26.6c0-1.1,0.5-2.2,1.3-3c0.8-0.8,1.9-1.3,3-1.3c1.1,0,2.2,0.5,3,1.3
			c0.8,0.8,1.3,1.9,1.3,3c0,0.3,0,0.6-0.1,0.8c0,0.1-0.1,0.2-0.1,0.3c0,0.1-0.1,0.3-0.1,0.4c-0.1,0.1-0.1,0.3-0.2,0.4L49.9,29
			c-0.1,0.1-0.2,0.3-0.3,0.4c-0.6,0.7-1.3,1.2-2.2,1.4c-0.9,0.2-1.8,0.2-2.6-0.1c-0.8-0.3-1.6-0.9-2.1-1.6
			C42.2,28.4,42,27.5,42,26.6z M25.7,2.3l0.7-0.1L28.6,2h0.2C34,1.6,39.2,1.6,44.4,2h0.2l2.3,0.2l0.6,0.1l1.2,0.2
			c-1,2.5-4,6.5-12.1,6.5c-8.1,0-11.1-4-12.1-6.5L25.7,2.3z M1.6,21.6c0-4.1,1.4-8.1,3.9-11.3C8.1,7.1,11.7,4.9,15.7,4
			c2.3-0.5,4.7-1,7.1-1.3c1,2.9,4.2,8,13.8,8s12.7-5.1,13.8-8C52.8,3,55.2,3.5,57.5,4c4,0.9,7.6,3.1,10.1,6.3
			c2.6,3.2,3.9,7.2,3.9,11.3V39c0,1.4-0.5,2.8-1.3,3.9c-0.8,1.1-2,2-3.4,2.4c-1.3,0.4-2.8,0.4-4.1-0.1c-1.3-0.5-2.5-1.3-3.3-2.5
			L51,30.2v-0.1c0.2-0.2,0.3-0.5,0.5-0.7v-0.1c0.1-0.2,0.2-0.5,0.3-0.7v-0.1c0.1-0.3,0.1-0.5,0.2-0.8v-0.2c0-0.3,0-0.6,0-0.9
			c0-1.6-0.6-3.1-1.7-4.2s-2.6-1.8-4.2-1.8c-0.1,0-0.2,0.1-0.4,0.1h-0.2l-0.4,0.1h-0.2l-0.3,0.1L44.3,21L44,21.1l-0.2,0.1l-0.3,0.1
			l-0.2,0.1L43,21.6l-0.2,0.1L42.6,22l-0.2,0.2l-0.2,0.2L42,22.5l-0.2,0.2l-0.2,0.2l-0.2,0.3l-0.1,0.2l-0.2,0.3l-0.1,0.2l-0.1,0.3
			l-0.1,0.2l-0.1,0.3L40.6,25l-0.1,0.3l-0.1,0.2c0,0.1,0,0.2,0,0.3v0.2h-7.4v-0.2c0-0.1,0-0.2,0-0.3v-0.2L33,25l-0.1-0.2l-0.4-0.3
			l-0.1-0.2l-0.1-0.3l-0.1-0.2L32,23.5l-0.1-0.2L31.7,23l-0.2-0.2l-0.2-0.2l-0.2-0.2l-0.2-0.2L30.7,22l-0.2-0.2l-0.2-0.1L30,21.5
			l-0.2-0.1l-0.3-0.1l-0.2-0.1L28.9,21l-0.2-0.1l-0.3-0.1h-0.2l-0.4-0.1h-0.2c-0.2,0-0.4,0-0.6,0c-1.6,0-3.1,0.6-4.2,1.8
			S21,25.2,21,26.7c0,0.3,0,0.6,0.1,0.9v0.2c0,0.3,0.1,0.5,0.2,0.8v0.1c0.1,0.3,0.2,0.5,0.3,0.7v0.1c0.1,0.3,0.3,0.5,0.5,0.7v0.1
			l-8.3,12.4c-0.8,1.2-1.9,2.1-3.3,2.5c-1.3,0.5-2.8,0.5-4.1,0.1C5,44.9,3.8,44.1,3,43c-0.8-1.1-1.3-2.5-1.3-3.9L1.6,21.6z"
        />
      </g>
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/resources/react-svg/Controller.js